import React, { useState } from 'react';
import { useSearchParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { isArray } from 'lodash';
import { AppBar, Tab, Tabs } from '@mui/material';

import { Workplaces } from '../Workplaces/Workplaces';
import { Products } from '../Products/Products';
import { Users } from '../Users/Users';

import { useUser } from 'utils/hooks/useUser';
import { useAppInfo } from 'utils/hooks/useAppInfo';
import { ConnectedModalities } from '../ConnectedModalities/ConnectedModalities';
import { Certificates } from '../Certificates/Certificates';

export const Settings: React.FC = () => {
  const { t } = useTranslation('Settings');
  const { hasRole } = useUser();
  const { compactMode } = useAppInfo();

  let [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab') || '';
  const tab = tabFromUrl
    ? isArray(tabFromUrl)
      ? tabFromUrl[0]
      : tabFromUrl
    : hasRole('ROLE_WORKPLACE')
    ? 'workplaces'
    : hasRole('ROLE_PRODUCT')
    ? 'products'
    : hasRole('ROLE_ADMINISTRATE_MODALITIES_IN_MARIE') ||
      hasRole('ROLE_ADMINISTRATE_MODALITIES_IN_DPGW')
    ? 'connectedModalities'
    : hasRole('ROLE_USER')
    ? 'users'
    : hasRole('ROLE_CAN_MANAGE_SIGNATURE_CERTIFICATES')
    ? 'certificates'
    : '';

  const [activeTab, setActiveTab] = useState<string>(tab);

  return (
    <>
      <AppBar position="static" color="default" sx={{ mb: compactMode ? 1 : 2 }}>
        <Tabs
          value={activeTab}
          onChange={(event, value) => setActiveTab(value)}
          indicatorColor="primary"
          textColor="primary"
          scrollButtons={false}
        >
          {hasRole('ROLE_WORKPLACE') && (
            <Tab value="workplaces" label={t('setWorkplaces')} data-pw="workplaces" />
          )}
          {hasRole('ROLE_PRODUCT') && (
            <Tab value="products" label={t('setProducts')} data-pw="products" />
          )}
          {(hasRole('ROLE_ADMINISTRATE_MODALITIES_IN_MARIE') ||
            hasRole('ROLE_ADMINISTRATE_MODALITIES_IN_DPGW')) && (
            <Tab
              value="connectedModalities"
              label={t('setConnectedModalities')}
              data-pw="connectedModalities"
            />
          )}
          {hasRole('ROLE_USER') && <Tab value="users" label={t('setUsers')} data-pw="users" />}
          {hasRole('ROLE_CAN_MANAGE_SIGNATURE_CERTIFICATES') && (
            <Tab
              value="certificates"
              label={t('Users:userProfileCertificates')}
              data-pw="certificates"
            />
          )}
        </Tabs>
      </AppBar>

      {activeTab === 'workplaces' && <Workplaces />}
      {activeTab === 'products' && <Products />}
      {activeTab === 'connectedModalities' && <ConnectedModalities />}
      {activeTab === 'users' && <Users />}
      {activeTab === 'certificates' && <Certificates />}
    </>
  );
};
